module.exports = __webpack_public_path__ + "files/66fd344eb7142b9b12f37d1e24f6e938.png";